import { render } from "./attributes.vue?vue&type=template&id=3c9f91e1&scoped=true&ts=true"
import script from "./attributes.vue?vue&type=script&lang=ts"
export * from "./attributes.vue?vue&type=script&lang=ts"

import "./attributes.vue?vue&type=style&index=0&id=3c9f91e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9f91e1"]])

export default __exports__